import { createSwansReducer } from '../../../infra/libs/redux-swans/createSwansReducer'
import { RootState } from '../root/RootState'

export const swansReducer = createSwansReducer((state: RootState) => state.swans)
